import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ScenariosService from "@services/ScenariosService";

export const viewScenario = createAsyncThunk(
  "scenario/view",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.viewScenario({
        id,
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const archiveScenario = createAsyncThunk(
  "scenario/archive",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.archiveScenario({
        id,
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const unArchiveScenario = createAsyncThunk(
  "scenario/restore",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.unArchiveScenario({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const deleteScenario = createAsyncThunk(
  "scenario/delete",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.deleteScenario({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  current: null,
  errors: null,
  error: "",
  status: "",
};

const viewScenarioSlice = createSlice({
  name: "view-scenario",
  initialState,
  reducers: {
    setCurrent(state, action) {
      state.current = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearView() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(viewScenario.pending, (state) => {
        pendingState(state);
      })
      .addCase(viewScenario.fulfilled, (state, action) => {
        state.current = action.payload;
        fulfilledState(state);
      })
      .addCase(viewScenario.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(archiveScenario.pending, (state) => {
        pendingState(state);
      })
      .addCase(archiveScenario.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(archiveScenario.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(unArchiveScenario.pending, (state) => {
        pendingState(state);
      })
      .addCase(unArchiveScenario.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(unArchiveScenario.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(deleteScenario.pending, (state) => {
        pendingState(state);
      })
      .addCase(deleteScenario.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(deleteScenario.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {clearView, setCurrent, setError, setStatus} =
  viewScenarioSlice.actions;
export default viewScenarioSlice.reducer;
